import { BreadcrumbLink, Breadcrumbs, BreadcrumbTypography } from '@ace-clublabs/shared-component-library';
import { useHistory } from 'react-router-dom';
import { Pages } from '../../utils/constants';

export interface IBreadcrumbsProps {
  additionalBreadcrumbName?: string;
}
export const MembershipBreadcrumbs = ({ additionalBreadcrumbName }: IBreadcrumbsProps) => {
  const history = useHistory();
  const defaultStyles = {
    fontSize: '0.875rem !important',
    ':visited': { color: '#1C4DA6', textDecorationColor: '#1C4DA6' },
  };
  return (
    <div className="membership-breadcrumbs">
      <Breadcrumbs sx={{ marginTop: '1.5rem' }}>
        <BreadcrumbLink href="https://account.app.ace.aaa.com" sx={defaultStyles}>
          My Account
        </BreadcrumbLink>
        {additionalBreadcrumbName ? (
          <BreadcrumbLink sx={defaultStyles} onClick={() => history.push(Pages.HomePage)}>
            My membership
          </BreadcrumbLink>
        ) : (
          <BreadcrumbTypography sx={defaultStyles}>My membership</BreadcrumbTypography>
        )}
        {additionalBreadcrumbName && (
          <BreadcrumbTypography sx={defaultStyles}>{additionalBreadcrumbName}</BreadcrumbTypography>
        )}
      </Breadcrumbs>
    </div>
  );
};
